<template>
  <router-link
    v-if="isVisible"
    :to="to"
    :class="[
      'flex flex-col items-center justify-center py-1.5 px-4 md:py-3 md:px-2 text-gray-800 hover:bg-gray-50 hover:text-primary transition-colors relative group border-b-2 md:border-b-0 md:border-l-4 border-transparent',
      isActive && '!bg-primary-50 !border-b-primary-500 md:!border-l-primary-500'
    ]"
  >
    <font-awesome-icon :icon="icon" :class="['w-5 h-5 md:mb-1', isActive && 'text-primary-500']" />
    <span class="text-xs font-medium text-center leading-none">{{ label }}</span>

    <!-- Tooltip on hover -->
    <div class="absolute top-full mt-2 md:top-auto md:left-full md:mt-0 md:ml-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
      {{ label }}
    </div>
  </router-link>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { canAccessRoute } from '@/utils/routeAccess';

export default {
  name: 'MainNavItem',
  components: {
    FontAwesomeIcon
  },
  props: {
    to: {
      type: String,
      required: true
    },
    icon: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    isActive() {
      // Match on a PATH BOUNDARY, not a bare prefix: a plain startsWith makes /engage
      // light up for /engagement/123, and /insight for /insightsnew.
      // The tab is active for its own path and its children, nothing else.
      const path = this.$route.path;
      return path === this.to || path.startsWith(`${this.to}/`);
    },
    isVisible() {
      return canAccessRoute(this.to, this.$router);
    }
  },
};
</script>

<style scoped>
</style>
